import HttpService from './HttpService';

const VesselActivitiesApi = HttpService('/api/vesselactivities/');
const doPost = (action, data) => VesselActivitiesApi.post(action, data);
const doGet = (url) => VesselActivitiesApi.get(url);
const doDelete = (url) => VesselActivitiesApi.delete(url);

export default {
  getVoyageVesselActivities(voyageReportId) {
    const apiAction = 'GetVesselActivities';
    const fullUrl = `${apiAction}?voyageReportId=${voyageReportId}`;
    return doGet(fullUrl);
  },
  createVesselActivity(activity) {
    return doPost('CreateVesselActivity', activity);
  },
  deleteVesselActivity(id) {
    const apiAction = 'DeleteVesselActivity';
    const fullUrl = `${apiAction}?id=${id}`;
    return doDelete(fullUrl);
  },
  updateVesselActivity(updateData) {
    return doPost('UpdateVesselActivity', updateData);
  },
};
